import { JavascriptError, JavascriptInfo, Kontrollrapport, RequestBodyParams } from '../types/generated';

declare global {
    interface Window {
        ENV: any;
    }
}

class Vadis {
    static getApiUrl(): string {
        const API_STI = "/api/v1";

        let miljoString: string;
        switch ((window.ENV || "").toLowerCase()) {
            case "dev":
                return API_STI;
            case "utv":
                miljoString = "utv.";
                break;
            case "test":
                miljoString = "test.";
                break;
            default:
                miljoString = "";
                break;
        }
console.log({miljoString});
        return `https://kontrollrapport.${miljoString}atlas.vegvesen.no${API_STI}`
    }

    static fellesKonfig: RequestInit = {
        credentials: "include"
    };

    static hentKontrollrapport(params?: RequestBodyParams): Promise<Kontrollrapport> {
        const {dokumentId, ...body}  = params ?? {}
        return fetch(`${this.getApiUrl()}/kontrollrapport`, {
            ...this.fellesKonfig,
            method: "post",
            body: JSON.stringify(body),
            headers: {"Content-Type": "application/json"}
        }).then((response) => {
            if (response.status !== 200) {
                return Promise.reject(response.status)
            } else {
                return response.json();
            }
        });
    }

    static logError(params: JavascriptError) {
        const body: JavascriptError = {
            url: params?.url ? params.url : window.location.href,
            application: params?.application ? params.application : "vadis-kontrollrapport-frontend",
            errorMessage: params?.errorMessage ? params.errorMessage : "An error occured",
        };
        fetch(`${this.getApiUrl()}/log/error`, {
            ...this.fellesKonfig,
            method: "post",
            body: JSON.stringify(body),
            headers: {"Content-Type": "application/json"}
        })
    }

    static logInfo(params: JavascriptInfo) {
        const body: JavascriptInfo = {
            url: params?.url ? params.url : window.location.href,
            application: params?.application ? params.application : "vadis-kontrollrapport-frontend",
            infoMessage: params?.infoMessage ? params.infoMessage : "",
        };
        fetch(`${this.getApiUrl()}/log/info`, {
            ...this.fellesKonfig,
            method: "post",
            body: JSON.stringify(body),
            headers: {"Content-Type": "application/json"}
        })
    }

    static loggUt() {
        return fetch(`${this.getApiUrl()}/loggut`, this.fellesKonfig)
    }
}

export default Vadis
